<template>
  <div class="forgot-page col-block" :style="{ minHeight: minHeight }">
    <div class="content-container col-block" :style="{ flex: 1 }">
      <div class="forgot-container col-block default-shadow">
        <div class="title-container sub-title center-block">
          <span>忘記密碼</span>
        </div>
        <div class="content-block" :style="{ width: '100%' }">
          <div>請輸入您註冊帳號時的E-mail，才能收取密碼修改郵件，若您有進一步的問題，請聯絡管理員。</div>
          <div>管理員信箱：<a href="mailto:agritrade@tari.gov.tw">agritrade@tari.gov.tw</a></div>
        </div>
        <div class="main-container">
          <div class="row">
            <div class="input-group no-padding col">電子信箱<span class="alert">*</span></div>
          </div>
          <div class="row">
            <div class="input-group col">
              <input type="text" id="email" name="email" v-model="forgot.email" v-validate="{ required: true, regex: matchEmail, max: 100 }">
              <p class="error" v-show="errors.has('email')">{{ (errors.first('email') || '').replace('email', 'E-mail') }}</p>
            </div>
          </div>
        </div>
        <div :style="{ flex: 1 }"></div>
        <div class="options-container row-block">
          <div :style="{ flex: 1 }"></div>
          <router-link :to="{ name: 'main' }">
            <button type="button" name="button" class="gray-button">
              <span>取消</span>
            </button>
          </router-link>
          <div :style="{ width: '20px' }"></div>
          <button type="button" name="button" class="main-button" :class="{ loading: onSubmit }" :disabled="onError" @click="e => validateForgotPassword()">
            <span>送出</span>
          </button>
          <div :style="{ flex: 1 }"></div>
        </div>
      </div>
      <div :style="{ flex: 1 }"></div>
    </div>
    <div class="footer-container">
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { postForgotUserPassword } from '../../api'
import loginMethods from '../../mixins/loginData'
import toastMethods from '../../mixins/toastMethods'
import { matchEmail } from '../../constants/global/regex'

export default {
  mixins: [
    loginMethods,
    toastMethods
  ],
  props: {
    minHeight: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      forgot: {
        email: ''
      },
      onSubmit: false
    }
  },
  computed: {
    onError () {
      let value = true
      if (this.errors.items.length === 0) {
        value = false
      }
      if (this.loading) {
        value = true
      }
      return value
    },
    // global
    matchEmail () { return matchEmail }
  },
  methods: {
    ...mapActions([
      'setModalAction'
    ]),
    async validateForgotPassword () {
      this.onSubmit = true
      let result = await this.$validator.validateAll()
      if (result) {
        await this.forgotPassword()
      } else {
        this.onSubmit = false
      }
    },
    async forgotPassword () {
      try {
        let data = {
          ...this.forgot,
          redirect_url: window.location.origin + '/reset'
        }
        await postForgotUserPassword(data)
        this.addToast('success', 'Email已寄出')
        this.$router.push({ name: 'main' })
        this.onSubmit = false
      } catch (error) {
        this.setLoginAction(false)
        this.addToast('error', !error.response ? error.message : error.response.data.message || error.response.data.errors.join('<br>'))
        this.onSubmit = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/main/forgot.vue